export default function removeNotification(notification) {
    return {
        type: removeNotification.type,
        payload: notification,
    };
}

removeNotification.type = 'REMOVE_NOTIFICATION';
